const queryGearLimited = params => {
  return `
  query gearDetailQuery($rootItem: String = "/sitecore/content/lynkco-global-portal/Content/Gear/*/*", $language: String = "${params.lang}") {
    search(fieldsEqual: [{name: "_fullpath", value: $rootItem}, {name: "spuId", value: "${params.spuId}"}], language: $language) {
      results {
        items {
          templateName
          id
          name
          path
          item {
            fields(ownFields: true) {
              ...itemField
            }
          }
        }
      }
    }
  }
  
  fragment itemField on ItemField {
    name
    value
    ... on ImageField {
      src
    }
    ... on FileField {
      mimeType
      size
      url
    }
    ... on LinkField {
      url
      text
    }
  }
  `;
};

export default queryGearLimited;
